export default "__VITE_ASSET__BURc4cRI__"